import { render, staticRenderFns } from "./Ag.vue?vue&type=template&id=189db136&scoped=true"
import script from "./Ag.vue?vue&type=script&lang=js"
export * from "./Ag.vue?vue&type=script&lang=js"
import style0 from "./Ag.vue?vue&type=style&index=0&id=189db136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189db136",
  null
  
)

export default component.exports